import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { ExportContainer } from "../../../Model/dataProcess/exportContainer";
import { LoginService } from "../../../Services/login.service";
import { ExportContainerService } from "../../../Services/DataProcess/export-container.service";

@Component({
    selector: 'app-export-stage',
    templateUrl: './export-stage.component.html',
    styleUrls: ['./export-stage.component.css'],
    standalone: false
})
export class ExportStageComponent implements OnInit {
    containers: ExportContainer[];
    editedContainer: ExportContainer;
    containerSearchText: string;
    containerEditVisible = false;
    selectedContainer: ExportContainer = null;

    constructor(
        public translate: TranslateService,
        private router: Router,
        private loginService: LoginService,
        private exportContainerService: ExportContainerService
    ) {
        this.altExpr = this.altExpr.bind(this);
    }

    async ngOnInit() {
        await this.reloadContainers();
    }

    async reloadContainers() {
        this.containers = await this.exportContainerService.getAll(this.loginService.currentCustomer.id) ?? [];
    }

    // Platzhalter
    calculateCategoryCount(_container: ExportContainer) {
        return 0;
    }

    calculateProductCount(_container: ExportContainer) {
        return 0;
    }

    calculateMediaCount(_container: ExportContainer) {
        return 0;
    }

    calculateSize(_container: ExportContainer) {
        return '–';
    }

    calculateUpdated(_container: ExportContainer) {
        return '–';
    }

    calculateType(_container: ExportContainer) {
        return '–';
    }

    imageExpr(container: ExportContainer): string {
        return container.logoLink;
    }

    altExpr(): string {
        return this.translate.instant("Fehler beim Laden des Logos");
    }

    onContainerClicked(event: any) {
        const data: ExportContainer = event?.card?.data ?? event?.data ?? null;
        if (data) {
            this.selectedContainer = data;
        }
    }

    goToDetails(container: ExportContainer) {
        const id = container?.id;
        if (id) {
            this.router.navigate(['/dataprocess/exports/container-details', id]);
        }
    }

    openContainerEditPopup() {
        this.containerEditVisible = true;
        this.editedContainer = new ExportContainer();
    }

    async onContainerSaved(container: ExportContainer) {
        let containerId = container.id;
        await this.reloadContainers();
        this.selectedContainer = this.containers.find(c => c.id === containerId) ?? null;
    }
}
